import ManageAccountsIcon from '@mui/icons-material/ManageAccounts'
import { IconButton, Tooltip } from '@mui/material'
import { userSettingsDialogVisibleVar } from 'context'

export const UserSettingsOption = () => {
  return (
    <Tooltip title="Display all member settings">
      <IconButton edge="start" onClick={() => userSettingsDialogVisibleVar(true)}>
        <ManageAccountsIcon />
      </IconButton>
    </Tooltip>
  )
}
